import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  DeliveryNoteProofOfDeliveryState,
  DeliveryNoteProofOfDeliveryStateModel,
} from './delivery-note-proof-of-delivery.state';
import {
  DeliveryNoteProofOfDeliveryDownloadFile,
  DeliveryNoteProofOfDeliveryInitialState,
  DeliveryNoteProofOfDeliveryLoad,
  DeliveryNoteProofOfDeliverySave,
  DeliveryNoteProofOfDeliverySendRequest,
} from './delivery-note-proof-of-delivery.actions';
import {
  LoadDataFacade,
  ProofOfDeliveryDownloadFileParams,
  ProofOfDeliverySaveParams,
  SetInitialStateFacade,
} from '../../../../../common';
import { DeliveryNoteItemFacade } from '../delivery-note-item.facade';
import { take } from 'rxjs/operators';
import { DeliveryNoteParams } from '../../models';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteProofOfDeliveryFacade implements LoadDataFacade, SetInitialStateFacade {
  proofOfDeliveryItemData$: Observable<DeliveryNoteProofOfDeliveryStateModel> = this.store.select(
    DeliveryNoteProofOfDeliveryState.getState,
  );
  isProofOfDeliveryExist$: Observable<boolean> = this.store.select(
    DeliveryNoteProofOfDeliveryState.isProofOfDeliveryExist,
  );
  loaded$: Observable<boolean> = this.store.select(DeliveryNoteProofOfDeliveryState.getLoaded);

  constructor(private store: Store, private deliveryNoteItemFacade: DeliveryNoteItemFacade) {}

  loadAll(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteProofOfDeliveryLoad(params));
  }
  saveProofOfDeliveryItem({ proofOfDeliveryItemValue }: ProofOfDeliverySaveParams): void {
    this.deliveryNoteItemFacade.deliveryNoteParams$
      .pipe(take(1))
      .subscribe(({ deliveryNoteNumber, sapId }: DeliveryNoteParams) => {
        this.store.dispatch(
          new DeliveryNoteProofOfDeliverySave({ deliveryNoteNumber, sapId, proofOfDeliveryItemValue }),
        );
      });
  }

  downloadFile({ documentId, name }: ProofOfDeliveryDownloadFileParams): void {
    this.deliveryNoteItemFacade.deliveryNoteParams$
      .pipe(take(1))
      .subscribe(({ deliveryNoteNumber, sapId }: DeliveryNoteParams) => {
        this.store.dispatch(
          new DeliveryNoteProofOfDeliveryDownloadFile({ deliveryNoteNumber, sapId, documentId, name }),
        );
      });
  }

  sendRequest(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNoteProofOfDeliverySendRequest(params));
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNoteProofOfDeliveryInitialState());
  }
}
